import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  margin: 8px auto;
  background-color: #ffffff;
  /* Neutral Colors/Gray 50 */
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border: 1px solid #ececec;
  border-radius: 8px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19.36px;
  letter-spacing: -0.01em;
  color: #333333;
  flex: 1;
  min-width: 0;
`;

export const Text = styled.p`
  font-family: "Inter";
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  padding: 4px 0;
  word-break: break-all;
  word-wrap: break-word;
  color: #424248;
`;

export const Date = styled.span`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  letter-spacing: -0.01em;
  white-space: nowrap;
  flex-shrink: 0;
  color: #999999;
  padding-top: 1px;
`;

export const NomeCorretor = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: -0.01em;
  white-space: normal;
  word-break: break-word;
  margin: auto 0;
  color: #333333;
`;

export const Body = styled.div`
  width: 100%;
`;

export const BodyTarefas = styled.div`
  width: 100%;
`;

export const AvatarBox = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Img = styled.img`
  &.img-corretor {
    width: 50%;
  }
`;

export const Footer = styled.div`
  width: 100%;
  display: inline-flex;
`;
